

import { FormComponent } from 'components/FormComponent';
import { SelectOption } from 'components/FormComponent/Select';

import { SearchBar } from '../SearchBar/SearchBar';

import { FilterButtons } from './FilterButtons';
import { ActiveFilters, FilterGroup } from './types';

type FilterAndSearchRowProps = {
  filterGroups: FilterGroup<any>[];
  activeFilters: ActiveFilters;
  handleFilterChange: (groupId: string, filterName: string) => void;
  query: string;
  setQuery: (query: string) => void;
  hideSearch?: boolean;
  useDropdown?: boolean; // Whether to use dropdown instead of filter buttons
};

/**
 * Filter and search bar row
 * @param param0
 * @returns
 */
export const FilterAndSearchRow = ({
  filterGroups, activeFilters, handleFilterChange, query, setQuery, hideSearch, useDropdown = false,
}: FilterAndSearchRowProps) => {
  return (
    <div className="flex flex-row justify-between gap-4">
      {filterGroups.length > 0 && (
        useDropdown ? (
          <div style={{ minWidth: '20rem' }}>
            {filterGroups.map(({ groupId, filters }) => {
              const options: SelectOption[] = filters.map(filter => ({ 
                value: filter.name, 
                label: filter.name 
              }));
              const currentValue = activeFilters[groupId] ? { 
                value: activeFilters[groupId], 
                label: activeFilters[groupId] 
              } : null;

              return (
                <FormComponent.ReactSelect
                  key={groupId}
                  options={options}
                  value={currentValue}
                  onChange={(newValue) => {
                    const option = newValue as SelectOption | null;
                    if (option) {
                      handleFilterChange(groupId, option.value);
                    }
                  }}
                  isSearchable={true}                 
                />
              );
            })}
          </div>
        ) : (
          <FilterButtons
            filterGroups={filterGroups}
            handleFilterChange={handleFilterChange}
            activeFilters={activeFilters}
          />
        )
      )}

      {filterGroups.length === 0 && (
        <div className="placeholder" />
      )}

      {!hideSearch && <SearchBar query={query} setQuery={setQuery} />}
    </div>
  );
};
